import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { FormContext, useForm } from 'react-hook-form'

import { LoadingFeedback } from 'components'
import { CalcExplanation, Cards, ScaleTable } from './components'

import useIncidentManegement from 'hooks/useIncidentManegement'
import useIncidentHighRisk from 'hooks/useIncidentHighRisk'
import useSnackbar from 'hooks/useSnackbar'

import useSchema from './schema'
import * as service from 'service'

const LargeScale = ({ refresh }) => {
  const snackbar = useSnackbar()

  const {
    isShow = false,
    incident,
    wantsToAdvanceStep,
    resetAdvanceStep,
  } = useIncidentManegement()

  const { handleHighRiskNext } = useIncidentHighRisk()

  const largeScale = incident?.highRisk?.largeScale
  const schema = useSchema(largeScale)

  const formMethods = useForm({
    validationSchema: schema,
  })

  const { getValues, triggerValidation, formState } = formMethods
  const [loading, setLoading] = useState(false)

  const { dirtyFields } = formState

  const isCreate = !largeScale[0]?.answer

  const buildDirtyAnswers = (answers = []) => {
    const dirtyFieldNames = Array.from(dirtyFields || [])

    return answers.filter((_, index) =>
      dirtyFieldNames.some((fieldName) =>
        fieldName.startsWith(`answers[${index}].`),
      ),
    )
  }

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      if (isShow) {
        resetAdvanceStep()
        handleHighRiskNext()
        return
      }
      const answers = largeScale.map((item, index) => {
        const rangeValue = data?.[`answers[${index}].range`]
        const answerValue = data?.[`answers[${index}].answer`]
        const selectedRange = item.classificationRanges?.find(
          (r) => r.id === rangeValue,
        )
        return {
          answer: index < 3 ? answerValue : selectedRange?.name,
          assignedValue: selectedRange?.assignedValue,
          incidentHighRiskQuestionId: item.id,
          incidentHighRiskClassificationRangeId: selectedRange?.id,
        }
      })
      const dirtyAnswers = buildDirtyAnswers(answers)

      if (!isCreate) {
        if (dirtyAnswers.length) {
          await service.dponet.incidents.updateHighRiskLargeScale({
            incidentId: incident?.id,
            highRiskAnswers: { answers: dirtyAnswers },
          })
        }
      }
      if (isCreate) {
        await service.dponet.incidents.createHighRiskLargeScale({
          incidentId: incident?.id,
          highRiskAnswers: { answers },
        })
      }

      refresh()
      resetAdvanceStep()
      handleHighRiskNext()
    } catch (error) {
      snackbar.open({
        message: 'Ocorreu um erro ao enviar as respostas',
        variant: 'error',
      })
    } finally {
      setLoading(false)
      resetAdvanceStep()
    }
  }

  useEffect(() => {
    const handleValidateAdvanceStep = async () => {
      if (wantsToAdvanceStep) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
        const isValid = await triggerValidation()

        if (isValid) {
          const data = getValues()
          await onSubmit(data)
        }
      }
      resetAdvanceStep()
    }
    handleValidateAdvanceStep()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantsToAdvanceStep])

  return (
    <FormContext {...formMethods}>
      <Box>
        <LoadingFeedback open={loading} />
        <Cards />
        <CalcExplanation />
        <Box>
          <form onSubmit={(e) => e.preventDefault()}>
            <ScaleTable />
          </form>
        </Box>
      </Box>
    </FormContext>
  )
}

LargeScale.propTypes = {
  refresh: PropTypes.func,
}

export default LargeScale
